"use strict";

var ExternalUrl = /* @__PURE__ */(ExternalUrl2 => {
  ExternalUrl2["ACCOUNT"] = "https://account.ui.com/";
  ExternalUrl2["BECOME_DISTRIBUTOR"] = "https://www.ui.com/distributors/become-authorized-distributor/";
  ExternalUrl2["CALENDAR"] = "https://www.ui.com/training/calendar/";
  ExternalUrl2["CAREERS"] = "https://careers.ui.com/";
  ExternalUrl2["COMMUNITY"] = "https://community.ui.com/";
  ExternalUrl2["CONTACT"] = "https://www.ui.com/contact/";
  ExternalUrl2["COURSES"] = "https://www.ui.com/training/";
  ExternalUrl2["COMPLIANCE"] = "https://www.ui.com/compliance/";
  ExternalUrl2["DESIGN_CENTER"] = "https://design.ui.com/";
  ExternalUrl2["FACEBOOK"] = "https://facebook.com/uieverywhere";
  ExternalUrl2["FIND_DISTRIBUTOR"] = "https://www.ui.com/distributors/";
  ExternalUrl2["INSTAGRAM"] = "https://www.instagram.com/ubiquiti/";
  ExternalUrl2["INVESTORS"] = "https://ir.ui.com/";
  ExternalUrl2["PARTNERS"] = "https://www.ui.com/training/partners/";
  ExternalUrl2["PRIVACY_POLICY"] = "https://www.ui.com/legal/privacypolicy/";
  ExternalUrl2["RETURN_POLICY"] = "https://www.ui.com/legal/ui-store/termsandconditions/#returns";
  ExternalUrl2["RMA"] = "https://rma.ui.com/";
  ExternalUrl2["STOCK_LOCATOR"] = "https://www.ui.com/distributors/stock-locator/";
  ExternalUrl2["SUPPORT"] = "https://help.ui.com/hc/en-us";
  ExternalUrl2["SUPPORT_UISP"] = "https://help.uisp.com/hc/en-us";
  ExternalUrl2["SITE_SUPPORT"] = "https://ui.com/site-support";
  ExternalUrl2["TERMS_SERVICE"] = "https://www.ui.com/legal/termsofservice/";
  ExternalUrl2["TRAINERS"] = "https://www.ui.com/training/become-trainer/";
  ExternalUrl2["TECH_SPECS"] = "https://techspecs.ui.com/";
  ExternalUrl2["X"] = "https://twitter.com/ubiquiti";
  ExternalUrl2["WIFIMAN"] = "https://wifiman.com/";
  ExternalUrl2["YOUTUBE"] = "https://www.youtube.com/user/ubnt?feature=watch";
  ExternalUrl2["UI_API_GEO_IP"] = "https://www.ui.com/api/geoip";
  ExternalUrl2["UI_COM"] = "https://www.ui.com/";
  ExternalUrl2["UI_DOWNLOADS"] = "https://www.ui.com/download";
  ExternalUrl2["UNIFI_SITE_MANAGER"] = "https://unifi.ui.com/";
  ExternalUrl2["UNIFI_SITE_MANAGER_CREATE"] = "https://unifi.ui.com/create-cloud-console";
  ExternalUrl2["UISP"] = "https://uisp.ui.com/";
  ExternalUrl2["UISP_DESIGN_CENTER"] = "https://ispdesign.ui.com/";
  ExternalUrl2["UISP_HOSTING"] = "https://uisp.ui.com/setup";
  ExternalUrl2["UI_WARRANTY"] = "https://www.ui.com/support/warranty/";
  ExternalUrl2["US_AMPLIFI_STORE"] = "https://store.amplifi.com/";
  ExternalUrl2["UI_SITE_SUPPORT"] = "https://ui.com/site-support/";
  ExternalUrl2["EXPERTS"] = "https://experts.ui.com/";
  ExternalUrl2["HELP_REQUEST_NEW"] = "https://help.ui.com/hc/en-us/requests/new";
  ExternalUrl2["MY_SUPPORT"] = "https://account.ui.com/mysupport";
  return ExternalUrl2;
})(ExternalUrl || {});
export { ExternalUrl };
//# sourceMappingURL=url.mjs.map
